import Joi from 'joi'
import {inputStringValidation} from 'validation'

export const automationFormSchema = Joi.object({
  name: inputStringValidation.min(2).required().messages({
    'string.empty': `Name cannot be an empty field`,
    'any.required': `Name is a required field`,
    'string.min': `Name length must be at least 2 characters long`,
  }),
  entity: Joi.string().messages({
    'string.base': `Entity must be selected`,
  }),
  domain: Joi.string()
    .max(30)
    .pattern(/^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+$/)
    .message('Please enter a valid domain.')
    .required()
    .messages({
      'string.empty': `Domain is required`,
      'any.required': `Domain is a required field`,
      'string.max': `Domain length must be less than 30 characters`,
    }),
  trigger: Joi.string().messages({
    'string.base': `Trigger must be selected`,
  }),
  labelId: Joi.number().allow(null),
  statusId: Joi.number().allow(null),
  priority: Joi.string().allow(null),
  assigneeId: Joi.number().allow(null),
  allowMultiple: Joi.boolean().allow(null),
  task: {
    subject: Joi.string().max(30).label('Task Subject').messages({
      'string.empty': `Subject cannot be an empty field`,
    }),
    type: Joi.string().trim().required(),
    status: Joi.string(),
    priority: Joi.string(),
    assigneeId: Joi.number().allow(null),
    description: Joi.string().max(200).allow(''),
    duration: Joi.number().integer().min(0).max(365).required().label('Task Duration').messages({
      'number.base': `Duration must be a number`,
    }),
  },
})
